import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ForumMockService } from '../forum-mock.service';
import { ForumComment, ForumCommunity, ForumPost, VoteValue } from '../forum.types';

@Component({
  selector: 'app-forum-post-detail',
  templateUrl: './forum-post-detail.component.html',
  styleUrls: ['./forum-post-detail.component.css'],
})
export class ForumPostDetailComponent implements OnInit {
  post?: ForumPost;
  community?: ForumCommunity;
  newComment = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private forum: ForumMockService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((pm) => {
      const id = pm.get('id') ?? '';
      this.post = this.forum.getPostById(id);
      this.community = this.post
        ? this.forum.getCommunityById(this.post.communityId)
        : undefined;
      window.scrollTo({ top: 0, behavior: 'auto' });
    });
  }

  votePost(value: VoteValue): void {
    if (this.post) this.forum.votePost(this.post, value);
  }

  voteComment(c: ForumComment, value: VoteValue): void {
    this.forum.voteComment(c, value);
  }

  toggleSave(): void {
    if (this.post) this.forum.toggleSave(this.post);
  }

  submitComment(): void {
    if (!this.post || this.newComment.trim().length < 2) return;
    this.forum.addComment(this.post, this.newComment);
    this.newComment = '';
  }

  back(): void {
    this.router.navigate(['/forum']);
  }

  openCommunity(): void {
    if (this.community) this.router.navigate(['/forum/c', this.community.slug]);
  }

  short(n: number): string {
    if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'k';
    return `${n}`;
  }
}
